import { SvgIcon } from "@mui/material";

export const MicrosoftIcon = () => {
    return (
        <SvgIcon>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <path fill="currentColor" d="M2 3h9v9H2V3m9 19H2v-9h9v9M21 3v9h-9V3h9m0 19h-9v-9h9v9Z"/>
            </svg>
        </SvgIcon>
    )
}